// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Medications-module__font-s-10___aCnhe {
  font-size: 10px !important;
}

.Medications-module__font-s-12___ny1Uk {
  font-size: 12px !important;
}

.Medications-module__font-s-13___g8O15 {
  font-size: 13px !important;
}

.Medications-module__font-s-14___ffsRE {
  font-size: 14px !important;
}

.Medications-module__font-s-15___ZwcxL {
  font-size: 15px !important;
}

.Medications-module__font-s-16___E0WgQ {
  font-size: 16px !important;
}

.Medications-module__font-s-18___J6VL_ {
  font-size: 18px !important;
}

.Medications-module__font-s-20___WTvTn {
  font-size: 20px !important;
}

.Medications-module__font-s-22___jDjSJ {
  font-size: 22px !important;
}

.Medications-module__font-s-28___VBqGk {
  font-size: 28px !important;
}

.Medications-module__font-w-400___pnGGr {
  font-weight: 400 !important;
}

.Medications-module__font-w-500___Izjkv {
  font-weight: 500 !important;
}

.Medications-module__font-w-600___zJiPH {
  font-weight: 600 !important;
}

.Medications-module__font-w-700___BRwtF {
  font-weight: 700 !important;
}

.Medications-module__p-5___HRsx6 {
  padding: 5px !important;
}

.Medications-module__p-12___bHYwF {
  padding: 12px !important;
}

.Medications-module__p-16___BkWfp {
  padding: 16px !important;
}

.Medications-module__p-30___Q_cuC {
  padding: 30px !important;
}

.Medications-module__p-b-0___xqKwN {
  padding-bottom: 0 !important;
}

.Medications-module__p-b-5___qCZe2 {
  padding-bottom: 5px !important;
}

.Medications-module__p-b-10___p4v9B {
  padding-bottom: 10px !important;
}

.Medications-module__p-b-12___Ts_in {
  padding-bottom: 12px !important;
}

.Medications-module__p-b-16___og23A {
  padding-bottom: 16px !important;
}

.Medications-module__p-b-18___bXKsJ {
  padding-bottom: 18px !important;
}

.Medications-module__p-b-20___sAum2 {
  padding-bottom: 20px !important;
}

.Medications-module__p-b-25___kbizc {
  padding-bottom: 25px !important;
}

.Medications-module__p-b-30___UWFqH {
  padding-bottom: 30px !important;
}

.Medications-module__p-b-50___DjyYF {
  padding-bottom: 50px !important;
}

.Medications-module__p-t-0___zE1B0 {
  padding-top: 0 !important;
}

.Medications-module__p-t-12___HM1TH {
  padding-top: 12px !important;
}

.Medications-module__p-t-16___c1LcW {
  padding-top: 16px !important;
}

.Medications-module__p-t-18___KPmOt {
  padding-top: 18px !important;
}

.Medications-module__p-t-20___nIugG {
  padding-top: 20px !important;
}

.Medications-module__p-t-30___Q17Ef {
  padding-top: 30px !important;
}

.Medications-module__p-t-40___yJymj {
  padding-top: 40px !important;
}

.Medications-module__p-t-50___IkS_v {
  padding-top: 50px !important;
}

.Medications-module__p-l-20___UDFKG {
  padding-left: 20px !important;
}

.Medications-module__p-l-30___Si_b0 {
  padding-left: 30px !important;
}

.Medications-module__p-l-40___x4hA3 {
  padding-left: 40px !important;
}

.Medications-module__p-r-16___UjVdu {
  padding-right: 16px !important;
}

.Medications-module__p-r-20___Xaqyl {
  padding-right: 20px !important;
}

.Medications-module__p-r-30___4mrNn {
  padding-right: 30px !important;
}

.Medications-module__p-r-50___D4C7J {
  padding-right: 50px !important;
}

.Medications-module__p-r-60___wtHx3 {
  padding-right: 60px !important;
}

.Medications-module__m-b-1___Fdfce {
  margin-bottom: 1px !important;
}

.Medications-module__m-b-2___fbxNN {
  margin-bottom: 2px !important;
}

.Medications-module__m-b-6___piZrf {
  margin-bottom: 6px !important;
}

.Medications-module__m-b-8___KGz5O {
  margin-bottom: 8px !important;
}

.Medications-module__m-b-10___MMJk9 {
  margin-bottom: 10px !important;
}

.Medications-module__m-b-14___MuJXR {
  margin-bottom: 14px !important;
}

.Medications-module__m-b-16___Nui2Y {
  margin-bottom: 16px !important;
}

.Medications-module__m-b-20___qiDr_ {
  margin-bottom: 20px !important;
}

.Medications-module__m-b-22___YMqzD {
  margin-bottom: 22px !important;
}

.Medications-module__m-b-24___kzdrd {
  margin-bottom: 24px !important;
}

.Medications-module__m-b-30___wMpp2 {
  margin-bottom: 30px !important;
}

.Medications-module__m-b-32___tV0tq {
  margin-bottom: 32px !important;
}

.Medications-module__m-b-40___h3oqn {
  margin-bottom: 40px !important;
}

.Medications-module__m-t-2___fw2hd {
  margin-top: 2px !important;
}

.Medications-module__m-t-3___AvzZn {
  margin-top: 3px !important;
}

.Medications-module__m-t-4___N93Hd {
  margin-top: 4px !important;
}

.Medications-module__m-t-5___Yn3F8 {
  margin-top: 5px !important;
}

.Medications-module__m-t-8___AOOFG {
  margin-top: 8px !important;
}

.Medications-module__m-t-10___aEoZ_ {
  margin-top: 10px !important;
}

.Medications-module__m-t-15___Xg4lz {
  margin-top: 15px !important;
}

.Medications-module__m-t-16___ajZye {
  margin-top: 16px !important;
}

.Medications-module__m-t-20___QL4H8 {
  margin-top: 20px !important;
}

.Medications-module__m-t-22___Em3PN {
  margin-top: 22px !important;
}

.Medications-module__m-t-30___wd5ZZ {
  margin-top: 30px !important;
}

.Medications-module__m-t-32___hIe2O {
  margin-top: 32px !important;
}

.Medications-module__m-l-auto___T4lqk {
  margin-left: auto !important;
}

.Medications-module__m-l-4___A2H2c {
  margin-left: 4px !important;
}

.Medications-module__m-l-5___axt83 {
  margin-left: 5px !important;
}

.Medications-module__m-l-6___oe4Tc {
  margin-left: 6px !important;
}

.Medications-module__m-l-8___y8UkF {
  margin-left: 8px !important;
}

.Medications-module__m-l-10___I7G8B {
  margin-left: 10px !important;
}

.Medications-module__m-l-16___o1WxW {
  margin-left: 16px !important;
}

.Medications-module__m-l-20___lSsoY {
  margin-left: 20px !important;
}

.Medications-module__m-l-24___S2CM9 {
  margin-left: 24px !important;
}

.Medications-module__m-l-30___QVU4p {
  margin-left: 30px !important;
}

.Medications-module__m-l-35___cEhmr {
  margin-left: 35px !important;
}

.Medications-module__m-l-40___I4nek {
  margin-left: 40px !important;
}

.Medications-module__m-r-8___sdwaS {
  margin-right: 8px !important;
}

.Medications-module__m-r-10___qvv_I {
  margin-right: 10px !important;
}

.Medications-module__m-r-16___bfwcx {
  margin-right: 16px !important;
}

.Medications-module__m-r-20___njX51 {
  margin-right: 20px !important;
}

.Medications-module__m-r-24___ISvUK {
  margin-right: 24px !important;
}

.Medications-module__m-r-30___EHzlL {
  margin-right: 30px !important;
}

.Medications-module__m-r-40___VuQwr {
  margin-right: 40px !important;
}

.Medications-module__border-r-3___s5oEO {
  border-radius: 3px !important;
}

.Medications-module__border-r-4___Ydjcf {
  border-radius: 4px !important;
}

.Medications-module__border-r-6___QmMg8 {
  border-radius: 6px !important;
}

.Medications-module__border-r-10___yKkMS {
  border-radius: 10px !important;
}

.Medications-module__border-r-12___cR22b {
  border-radius: 12px !important;
}

.Medications-module__border-r-16___ukqNd {
  border-radius: 16px !important;
}

.Medications-module__border-r-50___Y6GRi {
  border-radius: 50% !important;
}

.Medications-module__primary-border___zZ3jL {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-b___An3E6 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-t___pCjs2 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-l___UNbGo {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__primary-border-r___kGOTm {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Medications-module__secondary-border___Syf3H {
  border: 1px solid #637768;
}

.Medications-module__secondary-border-b___TneFz {
  border-bottom: 1px solid #637768;
}

.Medications-module__secondary-border-t___fDABW {
  border-top: 1px solid #637768;
}

.Medications-module__secondary-border-l___oelYD {
  border-left: 1px solid #637768;
}

.Medications-module__secondary-border-r___pVuea {
  border-right: 1px solid #637768;
}

.Medications-module__gap-0___cZCgb {
  gap: 0 !important;
}

.Medications-module__gap-2___VhUIk {
  gap: 2px !important;
}

.Medications-module__gap-4___AGU2A {
  gap: 4px !important;
}

.Medications-module__gap-5___wcC1U {
  gap: 5px !important;
}

.Medications-module__gap-6___lNgfz {
  gap: 6px !important;
}

.Medications-module__gap-8___HGyZ4 {
  gap: 8px !important;
}

.Medications-module__gap-10___gTfRf {
  gap: 10px !important;
}

.Medications-module__gap-12___s_Gdr {
  gap: 12px !important;
}

.Medications-module__gap-14___yB3Nh {
  gap: 14px !important;
}

.Medications-module__gap-16___whmSu {
  gap: 16px !important;
}

.Medications-module__gap-18___gKdNx {
  gap: 18px !important;
}

.Medications-module__gap-20___Fe8YA {
  gap: 20px !important;
}

.Medications-module__gap-24___PKIpd {
  gap: 24px !important;
}

.Medications-module__gap-26___W8oMk {
  gap: 26px !important;
}

.Medications-module__gap-30___aN7ql {
  gap: 30px !important;
}

.Medications-module__gap-32___PyKbw {
  gap: 32px !important;
}

.Medications-module__gap-40___rXws1 {
  gap: 40px !important;
}

.Medications-module__gap-50___XC3fR {
  gap: 50px !important;
}

.Medications-module__flex-1___wjtso {
  flex: 1;
}

.Medications-module__flex-none___ywu03 {
  flex: none !important;
}

.Medications-module__flex-column___ffaYd {
  display: flex;
  flex-direction: column !important;
}

.Medications-module__flex-row___yPRV5 {
  display: flex;
  flex-direction: row !important;
}

.Medications-module__vertically-centered___P9vtM {
  display: flex;
  align-items: center !important;
}

.Medications-module__horizontally-centered___Nb9WA {
  display: flex;
  justify-content: center !important;
}

.Medications-module__horizontally-end___AeNPy {
  display: flex;
  justify-content: end !important;
}

.Medications-module__vertically-start___pMq5O {
  display: flex;
  align-items: start !important;
}

.Medications-module__space-between___rexUA {
  display: flex;
  justify-content: space-between !important;
}

.Medications-module__flex-wrap___K8CJV {
  flex-wrap: wrap !important;
}

.Medications-module__height-100___NOc5m {
  height: 100%;
}

.Medications-module__width-50___RicaM {
  width: 50% !important;
}

.Medications-module__width-100___xmkTM {
  width: 100%;
}

.Medications-module__cursor-pointer___maa17 {
  cursor: pointer;
}

.Medications-module__cursor-not-allowed___kocpG {
  cursor: not-allowed !important;
}

.Medications-module__absolute-centered___RK5Ux {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Medications-module__absolute___E_qcy {
  position: absolute;
}

.Medications-module__relative___GytsL {
  position: relative;
}

.Medications-module__fixed___eXhm3 {
  position: fixed;
}

.Medications-module__visible___J9D9A {
  opacity: 1;
}

.Medications-module__invisible___o1iVO {
  opacity: 0;
}

.Medications-module__col-90___xkcRq {
  width: 90% !important;
}

.Medications-module__col-auto___VkT6X {
  width: auto !important;
}

.Medications-module__medical-tabs___MopRY {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Medications-module__medical-table-new___zCyry {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Medications-module__medical-table-new___zCyry:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Medications-module__medical-table-new___zCyry::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Medications-module__medical-table-new___zCyry::-webkit-scrollbar-track {
  display: none;
}
.Medications-module__medical-table-new___zCyry.Medications-module__no-pagination___ZqIfI {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Medications-module__medical-table-new___zCyry.Medications-module__no-pagination___ZqIfI:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Medications-module__medical-table-new___zCyry.Medications-module__no-pagination___ZqIfI::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Medications-module__medical-table-new___zCyry.Medications-module__no-pagination___ZqIfI::-webkit-scrollbar-track {
  display: none;
}

.Medications-module__medical-table-empty___grRPU {
  padding: 14px 40px !important;
}

.Medications-module__icon-btn___Dm070 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Medications-module__search-icon___F3oo6 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Medications-module__disable-select___AfIaX {
  user-select: none;
}

.Medications-module__break-word___ZnHoE {
  word-break: break-word;
}

.Medications-module__popup-clear-btn___mlngb {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Medications-module__scroll-m-b-20___xQtRe {
  scroll-margin-bottom: 20px;
}

.Medications-module__container___UKTHE {
  color: #375844;
  margin-bottom: -6px;
}
.Medications-module__container___UKTHE .Medications-module__toggleButton___ShkR_ {
  transition: transform 0.3s ease;
}
.Medications-module__container___UKTHE .Medications-module__collapsed___oGaVq {
  transform: rotate(180deg);
}
.Medications-module__container___UKTHE .Medications-module__expanded___FJ_GE {
  transform: rotate(0deg);
}
.Medications-module__container___UKTHE .Medications-module__grid___DiEAA {
  display: grid;
  column-gap: 30px;
  row-gap: 20px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.Medications-module__container___UKTHE .Medications-module__grid___DiEAA .Medications-module__width50___l_kKW {
  grid-column: span 2;
}
.Medications-module__container___UKTHE .Medications-module__grid___DiEAA .Medications-module__width100___jLQoS {
  grid-column: span 4;
}
.Medications-module__container___UKTHE .Medications-module__placeholder___g1bxj {
  color: #637768;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/MedicationsModule/Medications.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,+BAAA;AA8pBJ;AA3pBE;EACE,yBAAA;AA6pBJ;AA1pBE;EACE,uBAAA;AA4pBJ;AAzpBE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gDAAA;AA2pBJ;AAzpBI;EACE,mBAAA;AA2pBN;AAxpBI;EACE,mBAAA;AA0pBN;AAtpBE;EACE,cAAA;EACA,kBAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  margin-bottom: -6px;\n\n  .toggleButton {\n    transition: transform 0.3s ease;\n  }\n\n  .collapsed {\n    transform: rotate(180deg);\n  }\n\n  .expanded {\n    transform: rotate(0deg);\n  }\n\n  .grid {\n    display: grid;\n    column-gap: 30px;\n    row-gap: 20px;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n\n    .width50 {\n      grid-column: span 2;\n    }\n\n    .width100 {\n      grid-column: span 4;\n    }\n  }\n\n  .placeholder {\n    color: get-color(greenNew, medium-dark);\n    font-style: italic;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Medications-module__font-s-10___aCnhe`,
	"fontS12": `Medications-module__font-s-12___ny1Uk`,
	"fontS13": `Medications-module__font-s-13___g8O15`,
	"fontS14": `Medications-module__font-s-14___ffsRE`,
	"fontS15": `Medications-module__font-s-15___ZwcxL`,
	"fontS16": `Medications-module__font-s-16___E0WgQ`,
	"fontS18": `Medications-module__font-s-18___J6VL_`,
	"fontS20": `Medications-module__font-s-20___WTvTn`,
	"fontS22": `Medications-module__font-s-22___jDjSJ`,
	"fontS28": `Medications-module__font-s-28___VBqGk`,
	"fontW400": `Medications-module__font-w-400___pnGGr`,
	"fontW500": `Medications-module__font-w-500___Izjkv`,
	"fontW600": `Medications-module__font-w-600___zJiPH`,
	"fontW700": `Medications-module__font-w-700___BRwtF`,
	"p5": `Medications-module__p-5___HRsx6`,
	"p12": `Medications-module__p-12___bHYwF`,
	"p16": `Medications-module__p-16___BkWfp`,
	"p30": `Medications-module__p-30___Q_cuC`,
	"pB0": `Medications-module__p-b-0___xqKwN`,
	"pB5": `Medications-module__p-b-5___qCZe2`,
	"pB10": `Medications-module__p-b-10___p4v9B`,
	"pB12": `Medications-module__p-b-12___Ts_in`,
	"pB16": `Medications-module__p-b-16___og23A`,
	"pB18": `Medications-module__p-b-18___bXKsJ`,
	"pB20": `Medications-module__p-b-20___sAum2`,
	"pB25": `Medications-module__p-b-25___kbizc`,
	"pB30": `Medications-module__p-b-30___UWFqH`,
	"pB50": `Medications-module__p-b-50___DjyYF`,
	"pT0": `Medications-module__p-t-0___zE1B0`,
	"pT12": `Medications-module__p-t-12___HM1TH`,
	"pT16": `Medications-module__p-t-16___c1LcW`,
	"pT18": `Medications-module__p-t-18___KPmOt`,
	"pT20": `Medications-module__p-t-20___nIugG`,
	"pT30": `Medications-module__p-t-30___Q17Ef`,
	"pT40": `Medications-module__p-t-40___yJymj`,
	"pT50": `Medications-module__p-t-50___IkS_v`,
	"pL20": `Medications-module__p-l-20___UDFKG`,
	"pL30": `Medications-module__p-l-30___Si_b0`,
	"pL40": `Medications-module__p-l-40___x4hA3`,
	"pR16": `Medications-module__p-r-16___UjVdu`,
	"pR20": `Medications-module__p-r-20___Xaqyl`,
	"pR30": `Medications-module__p-r-30___4mrNn`,
	"pR50": `Medications-module__p-r-50___D4C7J`,
	"pR60": `Medications-module__p-r-60___wtHx3`,
	"mB1": `Medications-module__m-b-1___Fdfce`,
	"mB2": `Medications-module__m-b-2___fbxNN`,
	"mB6": `Medications-module__m-b-6___piZrf`,
	"mB8": `Medications-module__m-b-8___KGz5O`,
	"mB10": `Medications-module__m-b-10___MMJk9`,
	"mB14": `Medications-module__m-b-14___MuJXR`,
	"mB16": `Medications-module__m-b-16___Nui2Y`,
	"mB20": `Medications-module__m-b-20___qiDr_`,
	"mB22": `Medications-module__m-b-22___YMqzD`,
	"mB24": `Medications-module__m-b-24___kzdrd`,
	"mB30": `Medications-module__m-b-30___wMpp2`,
	"mB32": `Medications-module__m-b-32___tV0tq`,
	"mB40": `Medications-module__m-b-40___h3oqn`,
	"mT2": `Medications-module__m-t-2___fw2hd`,
	"mT3": `Medications-module__m-t-3___AvzZn`,
	"mT4": `Medications-module__m-t-4___N93Hd`,
	"mT5": `Medications-module__m-t-5___Yn3F8`,
	"mT8": `Medications-module__m-t-8___AOOFG`,
	"mT10": `Medications-module__m-t-10___aEoZ_`,
	"mT15": `Medications-module__m-t-15___Xg4lz`,
	"mT16": `Medications-module__m-t-16___ajZye`,
	"mT20": `Medications-module__m-t-20___QL4H8`,
	"mT22": `Medications-module__m-t-22___Em3PN`,
	"mT30": `Medications-module__m-t-30___wd5ZZ`,
	"mT32": `Medications-module__m-t-32___hIe2O`,
	"mLAuto": `Medications-module__m-l-auto___T4lqk`,
	"mL4": `Medications-module__m-l-4___A2H2c`,
	"mL5": `Medications-module__m-l-5___axt83`,
	"mL6": `Medications-module__m-l-6___oe4Tc`,
	"mL8": `Medications-module__m-l-8___y8UkF`,
	"mL10": `Medications-module__m-l-10___I7G8B`,
	"mL16": `Medications-module__m-l-16___o1WxW`,
	"mL20": `Medications-module__m-l-20___lSsoY`,
	"mL24": `Medications-module__m-l-24___S2CM9`,
	"mL30": `Medications-module__m-l-30___QVU4p`,
	"mL35": `Medications-module__m-l-35___cEhmr`,
	"mL40": `Medications-module__m-l-40___I4nek`,
	"mR8": `Medications-module__m-r-8___sdwaS`,
	"mR10": `Medications-module__m-r-10___qvv_I`,
	"mR16": `Medications-module__m-r-16___bfwcx`,
	"mR20": `Medications-module__m-r-20___njX51`,
	"mR24": `Medications-module__m-r-24___ISvUK`,
	"mR30": `Medications-module__m-r-30___EHzlL`,
	"mR40": `Medications-module__m-r-40___VuQwr`,
	"borderR3": `Medications-module__border-r-3___s5oEO`,
	"borderR4": `Medications-module__border-r-4___Ydjcf`,
	"borderR6": `Medications-module__border-r-6___QmMg8`,
	"borderR10": `Medications-module__border-r-10___yKkMS`,
	"borderR12": `Medications-module__border-r-12___cR22b`,
	"borderR16": `Medications-module__border-r-16___ukqNd`,
	"borderR50": `Medications-module__border-r-50___Y6GRi`,
	"primaryBorder": `Medications-module__primary-border___zZ3jL`,
	"primaryBorderB": `Medications-module__primary-border-b___An3E6`,
	"primaryBorderT": `Medications-module__primary-border-t___pCjs2`,
	"primaryBorderL": `Medications-module__primary-border-l___UNbGo`,
	"primaryBorderR": `Medications-module__primary-border-r___kGOTm`,
	"secondaryBorder": `Medications-module__secondary-border___Syf3H`,
	"secondaryBorderB": `Medications-module__secondary-border-b___TneFz`,
	"secondaryBorderT": `Medications-module__secondary-border-t___fDABW`,
	"secondaryBorderL": `Medications-module__secondary-border-l___oelYD`,
	"secondaryBorderR": `Medications-module__secondary-border-r___pVuea`,
	"gap0": `Medications-module__gap-0___cZCgb`,
	"gap2": `Medications-module__gap-2___VhUIk`,
	"gap4": `Medications-module__gap-4___AGU2A`,
	"gap5": `Medications-module__gap-5___wcC1U`,
	"gap6": `Medications-module__gap-6___lNgfz`,
	"gap8": `Medications-module__gap-8___HGyZ4`,
	"gap10": `Medications-module__gap-10___gTfRf`,
	"gap12": `Medications-module__gap-12___s_Gdr`,
	"gap14": `Medications-module__gap-14___yB3Nh`,
	"gap16": `Medications-module__gap-16___whmSu`,
	"gap18": `Medications-module__gap-18___gKdNx`,
	"gap20": `Medications-module__gap-20___Fe8YA`,
	"gap24": `Medications-module__gap-24___PKIpd`,
	"gap26": `Medications-module__gap-26___W8oMk`,
	"gap30": `Medications-module__gap-30___aN7ql`,
	"gap32": `Medications-module__gap-32___PyKbw`,
	"gap40": `Medications-module__gap-40___rXws1`,
	"gap50": `Medications-module__gap-50___XC3fR`,
	"flex1": `Medications-module__flex-1___wjtso`,
	"flexNone": `Medications-module__flex-none___ywu03`,
	"flexColumn": `Medications-module__flex-column___ffaYd`,
	"flexRow": `Medications-module__flex-row___yPRV5`,
	"verticallyCentered": `Medications-module__vertically-centered___P9vtM`,
	"horizontallyCentered": `Medications-module__horizontally-centered___Nb9WA`,
	"horizontallyEnd": `Medications-module__horizontally-end___AeNPy`,
	"verticallyStart": `Medications-module__vertically-start___pMq5O`,
	"spaceBetween": `Medications-module__space-between___rexUA`,
	"flexWrap": `Medications-module__flex-wrap___K8CJV`,
	"height100": `Medications-module__height-100___NOc5m`,
	"width50": `Medications-module__width-50___RicaM`,
	"width100": `Medications-module__width-100___xmkTM`,
	"cursorPointer": `Medications-module__cursor-pointer___maa17`,
	"cursorNotAllowed": `Medications-module__cursor-not-allowed___kocpG`,
	"absoluteCentered": `Medications-module__absolute-centered___RK5Ux`,
	"absolute": `Medications-module__absolute___E_qcy`,
	"relative": `Medications-module__relative___GytsL`,
	"fixed": `Medications-module__fixed___eXhm3`,
	"visible": `Medications-module__visible___J9D9A`,
	"invisible": `Medications-module__invisible___o1iVO`,
	"col90": `Medications-module__col-90___xkcRq`,
	"colAuto": `Medications-module__col-auto___VkT6X`,
	"medicalTabs": `Medications-module__medical-tabs___MopRY`,
	"medicalTableNew": `Medications-module__medical-table-new___zCyry`,
	"noPagination": `Medications-module__no-pagination___ZqIfI`,
	"medicalTableEmpty": `Medications-module__medical-table-empty___grRPU`,
	"iconBtn": `Medications-module__icon-btn___Dm070`,
	"searchIcon": `Medications-module__search-icon___F3oo6`,
	"disableSelect": `Medications-module__disable-select___AfIaX`,
	"breakWord": `Medications-module__break-word___ZnHoE`,
	"popupClearBtn": `Medications-module__popup-clear-btn___mlngb`,
	"scrollMB20": `Medications-module__scroll-m-b-20___xQtRe`,
	"container": `Medications-module__container___UKTHE`,
	"toggleButton": `Medications-module__toggleButton___ShkR_`,
	"collapsed": `Medications-module__collapsed___oGaVq`,
	"expanded": `Medications-module__expanded___FJ_GE`,
	"grid": `Medications-module__grid___DiEAA`,
	"width50": `Medications-module__width50___l_kKW`,
	"width100": `Medications-module__width100___jLQoS`,
	"placeholder": `Medications-module__placeholder___g1bxj`
};
module.exports = ___CSS_LOADER_EXPORT___;
